import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import type { Locale } from './locale';
import enJson from './en.json' assert { type: 'json' };
import frJson from './fr.json' assert { type: 'json' };

/**
 * By defining variables with the type of Locale we are utilizing TypeScript validation to ensure each language json
 * contains all of the properties defined in locale.ts
 */
const en: Locale = enJson;
const fr: Locale = frJson;
//Removing language set from localStorage so that it can be set to English
localStorage.removeItem('i18nextLng');

const languageDetectionOptions = {
  // order and from where user language should be detected
  order: [
    'querystring',
    'localStorage',
    'navigator',
  ],

  // keys or params to lookup language from
  lookupQuerystring: 'lng',
  lookupLocalStorage: 'i18nextLng',

  // cache user language on
  caches: ['localStorage'],
};

export type Language =
  'en' | 'fr';

export function getCurrentLanguage(): Language {
  return (i18next.language || 'en') as Language;
}

export function changeCurrentLanguage(language: Language): void {
  i18next.changeLanguage(language);
}

export function i18nInit(): void {
  i18next
    .use(initReactI18next)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    .init({
      fallbackLng: 'en',
      ns: Object.keys(en),
      resources: {
        en,
        fr
      },
      detection: languageDetectionOptions,
      debug: false,
      backend: {
        // Use a backend plugin to load translations asynchronously
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
    });
}  